export default __webpack_public_path__ + "static/media/icons.bf03a5a7.png";